import { render, staticRenderFns } from "./framework-sidebar-menu-item-subgroup.vue?vue&type=template&id=68686c10&"
import script from "./framework-sidebar-menu-item-subgroup.vue?vue&type=script&lang=js&"
export * from "./framework-sidebar-menu-item-subgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports